export default __webpack_public_path__ + "static/media/paul-card.61c7a251.svg";